import { render, staticRenderFns } from "./VxCellCredentialsEndsAt.vue?vue&type=template&id=4c8afca4&"
import script from "./VxCellCredentialsEndsAt.vue?vue&type=script&lang=js&"
export * from "./VxCellCredentialsEndsAt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports